/**
 * @file ClinicHeaderView.tsx
 * @copyright 2023 Boston Scientific Corporation
 * ********************************************************************************************************************
 * Copyright © 2023 Boston Scientific Corporation All rights reserved.
 *
 * This file and its contents are a product of Boston Scientific Corporation.  All software distributed by Boston
 * Scientific Neuromodulation is done so under a software license.  This file may not be copied or modified without
 * execution of the appropriate software license agreement with Boston Scientific Neuromodulation or explicit written
 * permission of Boston Scientific Neuromodulation.
 *
 * This file is provided as is, with no warranties of any kind including the warranties of design, merchantability and
 * fitness for a particular purpose, or arising from a course of dealing, usage or trade practice.
 *
 * Boston Scientific Neuromodulation shall have no liability with respect to the infringement of copyrights, trade
 * secrets or any patents by this file or any part thereof.
 *
 * In no event will Boston Scientific Neuromodulation be liable for any lost revenue or profits or other special,
 * indirect and consequential damages, even if Boston Scientific has been advised of the possibility of such damages,
 * as a result of the usage of this file and software for which this file is a part.
 * ********************************************************************************************************************
 *
 */
import { TableCell, TableHead, TableRow } from "@mui/material";
import React from "react";
import "./Table.css";

/**
 * A class definition for ClinicHeaderView
 */
export class ClinicHeaderView extends React.Component {

    render() {
        return <>
            <TableHead sx={{ width: '100%' }}>
                <TableRow className="ClinicTableHeader">
                    <TableCell align="left">
                        Name
                    </TableCell>
                    <TableCell align="left" className="TextNoWrap">
                        Clinic Account Number
                    </TableCell>
                    <TableCell align="left">
                        Added
                    </TableCell>
                </TableRow>
            </TableHead>
        </>
    }
}